<h2 mat-dialog-title>
  <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#user-s"></use></svg>
  Manuel behandling af bruger
</h2>
<button type="button" class="btn-close btn-icon" mat-dialog-close>
  <mat-icon>close</mat-icon>
</button>
@let idTags = idTags$ | async;

<mat-dialog-content>
  @if (missingIdTagGroup$ | async) {
    <div class="margin--bottom-l">
      <ok-feedback-fail>
        Der er ikke tilknyttet en id tag gruppe til brugerens organisation. Derfor kan man ikke oprette brikker til denne bruger.
      </ok-feedback-fail>
    </div>
  }
  <h2 class="form-headline">Bruger information</h2>
  <div class="grid-cols">
    <div>
      <table class="table table--center-vert">
        <tbody>
          <tr valign="top">
            <td style="width: 30%">
              <strong>Navn:</strong>
            </td>
            <td style="width: 70%" class="align-right">
              <div>
                {{ chargingUser.name }}
              </div>
            </td>
          </tr>
          @if (!editIdTagShippingAddress) {
            <tr valign="top">
              <td>
                <strong>Leveringsadresse:</strong>
              </td>
              <td>
                <div class="flex">
                  <div class="icon-with-text margin--left-auto">
                    @if (!editIdTagShippingAddress) {
                      <span [class.italic]="!chargingUser.idTagShippingAddress" [class.red]="!chargingUser.idTagShippingAddress">
                        {{ chargingUser.idTagShippingAddress ? chargingUser.idTagShippingAddress : 'ukendt' }}
                      </span>
                    }
                    @if (!hasCompanyCar && companyCarDetermined) {
                      @if (!editIdTagShippingAddress && !addressFoundAndSelected()) {
                        <button
                          class="btn-icon blue margin--left-s"
                          title="Rediger"
                          type="button"
                          (click)="editIdTagShippingAddress = true">
                          <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#edit-s"></use></svg>
                        </button>
                      }
                    }
                  </div>
                </div>
              </td>
            </tr>
          }
          @if (editIdTagShippingAddress) {
            <tr>
              <td colspan="2">
                <div class="form-row nolimits">
                  <form class="address-input nolimits" [formGroup]="addressForm" (submit)="saveIdTagShippingAddress()">
                    <adm-dep-address-typeahead
                      style="width: 100%"
                      [formRow]="false"
                      [parentFormGroup]="addressForm"
                      [addressWithoutDARValidation]="false"
                      [initialAddress]="initialAddress()"
                      (addressSelected)="selectAddress($event)" />

                    @if (addressFoundAndSelected()) {
                      <button
                        mat-raised-button
                        title="Gem"
                        color="secondary"
                        [disabled]="savingAddress || !addressForm.valid"
                        [class.spinner]="savingAddress"
                        (click)="saveIdTagShippingAddress()">
                        Gem
                      </button>
                    }
                    @if (editIdTagShippingAddress && !addressFoundAndSelected()) {
                      <button class="btn-icon" title="Annullér" (click)="editIdTagShippingAddress = false">
                        <mat-icon>close</mat-icon>
                      </button>
                    }
                  </form>
                </div>
              </td>
            </tr>
          }
          <tr valign="top">
            <td>
              <strong>E-mail adresse:</strong>
            </td>
            <td class="align-right">
              <div>
                {{ chargingUser.emailAddress ? chargingUser.emailAddress : '-' }}
              </div>
            </td>
          </tr>
          <tr valign="top">
            <td>
              <strong>Tlf.:</strong>
            </td>
            <td class="align-right">
              <div>+{{ chargingUser.phoneCountryCode }} {{ chargingUser.phoneNumber ? chargingUser.phoneNumber : '-' }}</div>
            </td>
          </tr>
          <tr valign="top">
            <td>
              <strong>Afdeling:</strong>
            </td>
            <td>
              <div class="flex">
                @if (!editDepartment) {
                  <div class="icon-with-text margin--left-auto">
                    <span>
                      {{ chargingUser.departmentName ? chargingUser.departmentName : '-' }}
                    </span>
                    <span>
                      <button class="btn-icon blue margin--left-s" title="Rediger" type="button" (click)="editDepartment = true">
                        <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#edit-s"></use></svg>
                      </button>
                    </span>
                  </div>
                }
              </div>
            </td>
          </tr>
          @if (editDepartment) {
            <tr valign="top">
              <td colspan="2">
                <form [formGroup]="editDepartmentFormGroup" class="nolimits">
                  <div class="edit-department align-right margin--bottom-l">
                    <mat-form-field>
                      <mat-label>Vælg afdeling</mat-label>
                      <mat-select formControlName="department" okCustomDropDownArrowDirective>
                        @for (department of departments; track department.id) {
                          <mat-option [value]="department">
                            {{ department.name }}
                          </mat-option>
                        }
                      </mat-select>
                      <mat-icon matSuffix></mat-icon>
                      <mat-hint class="text-warning">
                        Valg af afdeling indikerer blot hvor brik-brugen er tilknyttet i organisationen
                      </mat-hint>
                    </mat-form-field>
                    <div>
                      @if (editDepartment) {
                        <button
                          mat-raised-button
                          title="Gem"
                          color="secondary"
                          [disabled]="savingDepartment"
                          [class.spinner]="savingDepartment"
                          (click)="saveDepartment()">
                          Gem
                        </button>
                      }
                    </div>
                  </div>
                </form>
              </td>
            </tr>
          }
          <tr valign="top">
            <td>
              <strong>ID:</strong>
            </td>
            <td class="align-right">
              <div>
                {{ chargingUser.alias ? chargingUser.alias : '-' }}
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div>
      @if (!companyCarDetermined) {
        <ok-feedback-fail>
          <div>
            <p>Det er nødvendigt med yderligere oplysninger for at kunne tilknytte brikker til denne bruger.</p>
            <button (click)="openAddIdTagInfoModal()" mat-flat-button class="margin--top-m" color="primary">Tilknyt brikinformation</button>
          </div>
        </ok-feedback-fail>
      }
      @if (companyCarDetermined) {
        <table class="table">
          <tbody>
            <tr valign="top">
              <td>
                <strong>Firmabil</strong>
              </td>
              <td class="align-right">
                <div>
                  @if (hasCompanyCar) {
                    Ja
                  } @else {
                    Nej
                  }
                </div>
              </td>
            </tr>
            @if (hasCompanyCar && okAgreementNumberFormGroup && companyCarDetermined) {
              <tr>
                <td colspan="2">
                  <form [formGroup]="okAgreementNumberFormGroup" class="nolimits">
                    <div class="form-row nolimits">
                      <div class="account-number-input">
                        <div>
                          <adm-g4-agreement-number [control]="this.okAgreementNumberFormGroup.controls.agreementNumber" />
                          <mat-hint class="tiny-text mat-whitespace-fix">
                            Kun relevant hvis kunden har en firmabil: Indtastet aftalenr bliver brugt til at fakturere alt forbrug for
                            brikkerne tilknyttet brugeren
                          </mat-hint>
                        </div>
                        <button
                          mat-raised-button
                          title="Gem"
                          color="secondary"
                          [disabled]="saving() || okAgreementNumberFormGroup.invalid"
                          [class.spinner]="saving()"
                          (click)="saveAgreementNumber()">
                          Gem
                        </button>
                      </div>
                    </div>
                  </form>
                </td>
              </tr>
              <tr valign="top">
                <td>
                  <strong>G4 Aftalenr.:</strong>
                </td>
                <td class="align-right">
                  @if (chargingUser.agreementNumber > 0) {
                    <div>
                      {{ chargingUser.agreementNumber }}
                    </div>
                  }
                </td>
              </tr>
            }
            @if (!hasCompanyCar && companyCarDetermined) {
              <tr>
                <td colspan="2">
                  <form [formGroup]="okAccountFormGroup" class="nolimits">
                    <div class="form-row nolimits">
                      <div class="account-number-input">
                        <div>
                          <adm-g4-account-number [control]="okAccountFormGroup.controls.invoicingAccountNumber" />
                          <mat-hint class="tiny-text mat-whitespace-fix">
                            Kun relevant hvis kunden ikke har en firmabil: Indtastet kontonr bliver brugt til at fakturere alt forbrug for
                            brikkerne tilknyttet brugeren
                          </mat-hint>
                        </div>
                        @if (okAccountFormGroup) {
                          <button
                            mat-raised-button
                            title="Gem"
                            color="secondary"
                            [disabled]="saving() || !okAccountFormGroup.valid"
                            [class.spinner]="saving()"
                            (click)="saveInvoicingAccountNumber()">
                            Gem
                          </button>
                        }
                      </div>
                    </div>
                  </form>
                </td>
              </tr>
              <tr valign="top">
                <td>
                  <strong>G4 Kontonr.:</strong>
                </td>
                <td class="align-right">
                  @if (chargingUser.invoicingAccountNumber > 0) {
                    <div>
                      {{ chargingUser.invoicingAccountNumber }}
                    </div>
                  }
                </td>
              </tr>
              @if (chargingUser.cprNumber) {
                <tr valign="top">
                  <td>
                    <strong>CPR nr:</strong>
                  </td>
                  <td class="align-right">
                    {{ chargingUser.cprNumber }}
                  </td>
                </tr>
              }
              @if (chargingUser.bankRegistrationNumber && chargingUser.bankAccountNumber) {
                <tr valign="top">
                  <td>
                    <strong>Betalingskonto nr.:</strong>
                  </td>
                  <td class="align-right">
                    <div>{{ chargingUser.bankRegistrationNumber }} {{ chargingUser.bankAccountNumber }}</div>
                  </td>
                </tr>
              }
            }
            <tr valign="top">
              <td>
                <strong>Indtastede briknumre:</strong>
              </td>
              <td class="align-right">
                <div>
                  {{ chargingUser.printedIds }}
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      }
    </div>
  </div>

  <div class="form-row form-row--multi-select nolimits">
    <div class="id-tag-header">
      <h2 class="form-headline">Brikker</h2>
      @if (idTags) {
        @if (idTags.length > 0) {
          <a
            class="text-right margin--top-m blue"
            (click)="close()"
            [routerLink]="['/id-tags']"
            [queryParams]="{ chargingUserId: chargingUser.id, includeInactive: true }">
            Brik-liste for disse brikker
          </a>
        }
      }
    </div>
    @if (hasCompanyCar && !chargingUser.agreementNumber && companyCarDetermined) {
      <ok-feedback-fail>
        <div>
          Da kunden har firmabil skal G4 Aftalenr. ovenfor udfyldes og gemmes inden der kan tilføjes brikker til kunden.
          @if (agreementNumberFromDepartment()) {
            <button mat-flat-button color="primary" (click)="addAgreementNumberFromDepartment()" class="add-button">
              Tilføj afdelingens G4 Aftalenr.
            </button>
          } @else {
            <em>
              <br />
              Afdeling har ikke aftalenr. på sig
            </em>
          }
        </div>
      </ok-feedback-fail>
    }
    @if (!hasCompanyCar && !chargingUser.invoicingAccountNumber && companyCarDetermined) {
      <ok-feedback-fail>
        Da kunden ikke har firmabil skal G4 Kontonr. ovenfor udfyldes og gemmes inden der kan tilføjes brikker til kunden.
      </ok-feedback-fail>
    }
    @if (!hasDeliveryAddress() && companyCarDetermined) {
      <ok-feedback-fail>
        <div>
          <strong>En leveringsadresse er påkrævet for at oprette en brik</strong>
          <br />
          <span>Hvis brugeren har firmabil er det typisk brugerens afdeling, der bruges som leveringsadresse.</span>
          <br />
          <span>Hvis brugeren ikke har firmabil skal leveringsadressen være indtastet på brugeren</span>
        </div>
      </ok-feedback-fail>
    }
    @if (!companyCarDetermined) {
      <ok-feedback-fail>
        Da der ikke er taget stilling til om brugeren har firmabil eller ej, kan der ikke tilknyttes brikker til brugeren
      </ok-feedback-fail>
    }
    @if (!chargingUserHasDepartment) {
      <ok-feedback-fail>
        Brugeren har ingen afdeling tilknyttet. Dette kan gøres ovenfor på blyant-ikonet ud for 'Afdeling
      </ok-feedback-fail>
    }

    @if (
      hasDeliveryAddress() &&
      (hasCompanyCar || chargingUser.invoicingAccountNumber) &&
      (!hasCompanyCar || chargingUser.agreementNumber) &&
      companyCarDetermined &&
      chargingUserHasDepartment
    ) {
      <div class="multi-select">
        <div class="multi-select__list">
          @if (idTags) {
            @for (idTag of idTags; track idTag.id; let i = $index) {
              <div class="multi-select__item multi-select__item--tall">
                <div class="multi-select__item-title padding--left-none">
                  @if (idTag.status.toString() === idTagStatusEnum[idTagStatusEnum.Pending]) {
                    <mat-chip class="secondary"> Afventer behandling </mat-chip>
                  }
                  @if (idTag.status.toString() === idTagStatusEnum[idTagStatusEnum.Active]) {
                    <mat-chip class="success">Aktiv</mat-chip>
                  }
                  @if (idTag.status.toString() === idTagStatusEnum[idTagStatusEnum.Inactive]) {
                    <mat-chip class="warn">Inaktiv</mat-chip>
                  }
                  @if (idTag.status.toString() === idTagStatusEnum[idTagStatusEnum.NoIdTagGroup]) {
                    <mat-chip class="danger"> Adgang fjernet </mat-chip>
                  }
                  @if (idTag.status.toString() === idTagStatusEnum[idTagStatusEnum.Blocked]) {
                    <mat-chip class="danger">Spærret</mat-chip>
                  }
                </div>
                <div class="multi-select__item-title">
                  <strong>Beskrivelse:</strong>
                  <span>&nbsp;{{ idTag.description }}</span>
                </div>
                <div class="multi-select__item-title">
                  <strong>Brik ID:</strong>
                  <span>&nbsp;{{ idTag.printedId }}</span>
                </div>
                <div class="multi-select__item-title">
                  <strong>RFID:</strong>
                  <span>&nbsp;{{ idTag.idToken }}</span>
                </div>
                <button
                  mat-icon-button
                  class="delete"
                  title="Fjern"
                  type="button"
                  (click)="deleteIdTag(idTag)"
                  [disabled]="idTag.status.toString() !== idTagStatusEnum[idTagStatusEnum.Active]">
                  <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#trash-s"></use></svg>
                </button>
              </div>
            }
          }
          @if (chargingUser.deleted) {
            <div class="multi-select__input">
              <mat-hint>
                <span class="italic">Da brugeren er slettet, kan der ikke oprettes nye brikker</span>
              </mat-hint>
            </div>
          }
          @if (!chargingUser.deleted) {
            <div class="multi-select__input">
              <form [formGroup]="idTagFormGroup" autocomplete="off" class="nolimits">
                <mat-form-field>
                  <mat-label>Brik ID</mat-label>
                  <input
                    type="text"
                    required=""
                    placeholder="Brikkens ID..."
                    matInput
                    [matAutocomplete]="auto"
                    formControlName="printedId"
                    maxlength="6" />

                  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectIdTag($event.option.value)">
                    @for (option of filteredLookupIdTags; track option.printedId) {
                      <mat-option [value]="option.printedId">
                        {{ option.printedId }}
                      </mat-option>
                    }
                  </mat-autocomplete>

                  <mat-hint align="end">{{ queriedPrintedId?.toString()?.length ?? 0 }}/6 cifre</mat-hint>

                  <mat-error>
                    @if (printedId.errors && printedId.errors['printedIdAlreadyUsed']) {
                      Brik ID {{ queriedPrintedId }} er optaget
                    }
                    @if (printedId.errors && printedId.errors['foundNoPrintedIds']) {
                      Der blev ikke fundet nogen brik ID'er
                    }
                    @if (printedId.errors && (printedId.errors['required'] || printedId.errors['pattern'])) {
                      Brikkens ID består af et tal mellem 1 og 6 cifre
                    }
                  </mat-error>
                </mat-form-field>

                <mat-form-field>
                  <mat-label>RFID</mat-label>
                  <input matInput placeholder="RFID" formControlName="idToken" readonly />
                  @if (idTagFormGroup.controls['idToken'].invalid) {
                    <mat-error [innerHTML]="getErrorMessage('idToken')"></mat-error>
                  }
                </mat-form-field>

                <button
                  mat-flat-button
                  color="primary"
                  title="Tilføj"
                  (click)="createIdTag()"
                  class="add-button"
                  [disabled]="savingIdTag || idTagFormGroup.invalid || (missingIdTagGroup$ | async)"
                  [class.spinner]="savingIdTag">
                  <svg class="icon-20"><use href="assets/images/ok-icons-sprite.svg#plus-s"></use></svg>
                </button>
              </form>
            </div>
          }
        </div>
      </div>
    }
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <div class="unit-identifier">
    <span>Bruger ID:</span>
    {{ chargingUser.id }}
  </div>
  <button type="button" mat-button (click)="close()">Luk</button>
</mat-dialog-actions>
